'use strict'

module.exports = {
  startupLog: () => {},
  setStartupLogConfig: () => {},
  setStartupLogInstrumenter: () => {},
  setSamplingRules: () => {}
}
